import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";

class MarriageDivorceRecordDetail extends Component {
  getFirstPersonRecordDetail = (node, props, type, index, colorClass) => (
    <Table.Row key={`row_${type}_${index}`} className={colorClass}>
      <Table.Cell className={"text-bold"}>First Person:</Table.Cell>
      <Table.Cell>
        {getPersonName(
          _.get(node, "firstPersonFirst[0]._", ""),
          _.get(node, "firstPersonMiddle[0]._", ""),
          _.get(node, "firstPersonLast[0]._", ""),
          props
        )}
      </Table.Cell>
      <Table.Cell className={"text-bold"}>County State:</Table.Cell>
      <Table.Cell>{`${_.get(node, "county[0]._", "")} ${_.get(
        node,
        "state[0]._",
        ""
      )}`}</Table.Cell>
    </Table.Row>
  );

  getSecondPersonRecordDetail = (node, props, type, index, colorClass) => (
    <Table.Row key={`row2_${type}_${index}`} className={colorClass}>
      <Table.Cell className={"text-bold"}>Second Person:</Table.Cell>
      <Table.Cell>
        {getPersonName(
          _.get(node, "secondPersonFirst[0]._", ""),
          _.get(node, "secondPersonMiddle[0]._", ""),
          _.get(node, "secondPersonLast[0]._", ""),
          props
        )}
      </Table.Cell>
      <Table.Cell className={"text-bold"}>Date:</Table.Cell>
      <Table.Cell>{_.get(node, "date[0]._", "")}</Table.Cell>
    </Table.Row>
  );

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const marriageNodes = _.get(node, "marriages[0].record");
      const marriageRows = [];
      if (marriageNodes) {
        _.forEach(marriageNodes, (marriageNode, marriageIndex) => {
          const colorClass = marriageIndex % 2 === 0 ? "odd-row" : "even-row";
          marriageRows.push(
            this.getFirstPersonRecordDetail(
              marriageNode,
              this.props,
              "marriage",
              `${this.props.index}_${marriageIndex}`,
              colorClass
            )
          );
          marriageRows.push(
            this.getSecondPersonRecordDetail(
              marriageNode,
              this.props,
              "marriage",
              `${this.props.index}_${marriageIndex}`,
              colorClass
            )
          );
        });

        if (marriageRows.length > 0) {
          results.push(
            <Table.Row key={`row_marriage_header`}>
              <Table.Cell colSpan={100}>
                <Table>
                  <Table.Body>
                    <Table.Row key={`row_marriage_record_header`}>
                      <Table.Cell
                        colSpan={100}
                        className="report-sub-section-header"
                      >
                        Marriages
                      </Table.Cell>
                    </Table.Row>
                    {marriageRows}
                  </Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        }
        const divorceNodes = _.get(node, "divorces[0].record");
        const divorceRows = [];
        if (divorceNodes) {
          _.forEach(divorceNodes, (divorceNode, divorceIndex) => {
            const colorClass = divorceIndex % 2 === 0 ? "odd-row" : "even-row";
            divorceRows.push(
              this.getFirstPersonRecordDetail(
                divorceNode,
                this.props,
                "divorce",
                `${this.props.index}_${divorceIndex}`,
                colorClass
              )
            );
            divorceRows.push(
              this.getSecondPersonRecordDetail(
                divorceNode,
                this.props,
                "divorce",
                `${this.props.index}_${divorceIndex}`,
                colorClass
              )
            );
          });
        }
        if (divorceRows.length < 1) {
          divorceRows.push(
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={2}>No Records found</Table.Cell>
            </Table.Row>
          );
        }
        results.push(
          <Table.Row key={`row_marriage_header`}>
            <Table.Cell colSpan={100}>
              <Table>
                <Table.Body>
                  <Table.Row key={`row_marriage_record_header`}>
                    <Table.Cell
                      colSpan={100}
                      className="report-sub-section-header"
                    >
                      Divorces
                    </Table.Cell>
                  </Table.Row>
                  {divorceRows}
                </Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
        );
      }
    }
    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default MarriageDivorceRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/MarriageDivorceRecordDetail.js